import { LoaderType, NextgenImage, useTranslation } from '@nextgen-web-framework/all';
import styles from './PageLoader.module.scss';
const PageLoader = () => {
  const t = useTranslation();
  return (
    <div className={styles['page-loader-container']} data-testid="page-loader-testid">
      <div className={styles['page-loader-img']}>
        <NextgenImage
          loaderType={LoaderType.WEBFONTS}
          isRelativeURL={true}
          src={`${'/images/Loading.svg'}` || ''}
          alt={t('identity.loader.title.alt')}
        />
      </div>
      <div className={styles['page-loader-detail']}>
        <div className={styles['page-loader-greeting']}>{t('identity.loader.title')}</div>
        <div className={styles['page-loader-message']}>{t('identity.loader.description')}</div>
      </div>
      <div className={styles['page-loader-icon']}>
        <NextgenImage
          loaderType={LoaderType.WEBFONTS}
          isRelativeURL={true}
          src={`${'/icons/Spinner.svg'}` || ''}
          alt={t('identity.loader.description.alt')}
        />
      </div>
    </div>
  );
};

export default PageLoader;
